import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PropsWithChildren } from 'react';
import { environment } from 'services/environment/Environment';

const client = new QueryClient();

export default function QueryProvider({ children }: PropsWithChildren<{}>) {
  const isDevelopment = environment().node.nodeEnv === 'development';

  return (
    <QueryClientProvider client={client}>
      {children}
      {isDevelopment && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}
